/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The type of the user.
 */
export type UserType = (typeof UserType)[keyof typeof UserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserType = {
  AUDIOLOGIST: "AUDIOLOGIST",
  SUPPLIER: "SUPPLIER",
  ERP_SUPPLIER: "ERP_SUPPLIER",
  ADMIN: "ADMIN",
} as const;
